document.addEventListener('click', async (event) => {
  const swatch = event.target.closest('[data-colorway-link]');

  if (!swatch) return;

  const productInfo = swatch.closest('product-info');
  const variantPicker = productInfo?.querySelector('variant-selects, variant-radios');

  if (!productInfo || !variantPicker) return;

  event.preventDefault();

  const selectedOptions = Array.from(
    variantPicker.querySelectorAll('select, input[type="radio"]:checked')
  )
    .map((input) => input.value)
    .filter(Boolean);

  const currentSize = selectedOptions[0];

  if (!currentSize) {
    window.location.href = swatch.href;
    return;
  }

  try {
    const response = await fetch(`${swatch.dataset.productUrl}.js`);

    if (!response.ok) {
      throw new Error('Could not load destination product.');
    }

    const destinationProduct = await response.json();

    const matchingVariant = destinationProduct.variants.find((variant) => {
      return variant.options.includes(currentSize);
    });

    const destinationUrl = new URL(swatch.href, window.location.origin);

    if (matchingVariant) {
      destinationUrl.searchParams.set('variant', matchingVariant.id);
    }

    window.location.href = destinationUrl.toString();
  } catch (error) {
    console.error('Related colorway size matching failed:', error);
    window.location.href = swatch.href;
  }
});